import logoEp from "../images/logo-ep.png";
import logoTb from "../images/logo-tb.png";

const brandConfig = [
	{
		name: "Testbase",
		brand: "TB",
		theme: "theme-tb",
		logo: logoTb,
		invoiceType: 1,
		sites: 1,
		siteIdentifier: "p",
		pageTitle: "Testbase - Order Testbase Today",
		favicon: "https://app.doublestruck.eu/images/fav/TB.ico",
		printableOrderForm: "https://forms.testbase.co.uk/sec/assets/resources/tb_orderform.pdf",
		mainSiteURL: "https://www.testbase.co.uk/",
	},
	{
		name: "Exampro",
		brand: "EP",
		theme: "theme-ep",
		logo: logoEp,
		invoiceType: 2,
		sites: 2,
		siteIdentifier: "s",
		pageTitle: "Exampro - Order Exampro Today",
		favicon: "https://app.doublestruck.eu/images/fav/EP.ico",
		printableOrderForm: "https://forms.exampro.co.uk/sec/resources/ep_orderform.pdf",
		mainSiteURL: "https://www.exampro.co.uk/",
	},
];

export default brandConfig;
